import ability from './ability'

export const canNavigate = to => to.matched.some(route => {
  const action = route.meta.action || 'read'
  const resource = route.meta.resource
  if (!resource) return false
  if (Array.isArray(resource)) {
    return resource.some(item => ability.can(action, item))
  }
  return ability.can(action, resource)
})

export const _ = undefined
